import styled from "styled-components"

import Card from "../../Layout/Card"
import {StyledFeedItem} from "./FeedItem"

export const StyledFeed = styled(Card)`
  position: relative;
  padding: 0;
  border-radius: 3px;

  ${StyledFeedItem} {
    :hover {
      background-color: ${({theme}) => theme.colors.greys.lightest};
      cursor: pointer;
    }
  }
  ${StyledFeedItem}:first-child {
    border-radius: 6px 6px 0 0;
  }
`
